
import React from 'react';
import PersonalInfoSection from './sections/PersonalInfoSection';
import InterviewContentSection from './sections/InterviewContentSection';

const FormFields = ({ form }) => {
  console.log('[CRITICAL FORMFIELDS] FormFields component rendered - MUST APPEAR IN CONSOLE');
  
  return (
    <div className="grid gap-5">      
      {/* Date and personal information */}
      <PersonalInfoSection form={form} />
      
      {/* Interview content */}
      <InterviewContentSection form={form} />
    </div>
  );
};

export default FormFields;
